import React from 'react'

export default function HTag({ tag = 'h2', text, className, ...props }) {
	if (!text) return null

	return React.createElement(
		tag || 'h2',
		{
			className,
			...props
		},
		text
	)
}
